import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ua'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'

Vue.use(Element, { locale })
